export default __webpack_public_path__ + "img/Image-DevOps-Pages-1.2fc48ec2.jpg";